import { useMemo } from "react";
import { useStoryblokProxy } from "./useStoryblokProxy";
import type { ISbStoryData } from "@storyblok/react";

/**
 * Fetch story slugs for a list of Storyblok UUIDs in a given language.
 * Returns a map of uuid -> full_slug for the specified language (default: 'en').
 */
export const useStoryblokTranslatedSlugs = (
  uuids: string[] | undefined,
  language: string = "en"
) => {
  const unique = useMemo(() => Array.from(new Set(uuids ?? [])), [uuids]);

  const { data, isLoading, isError } = useStoryblokProxy(
    unique.length
      ? {
          by_uuids: unique.join(","),
          language,
          per_page: unique.length,
        }
      : { by_uuids: "" },
    unique.length === 0
  );

  const map = useMemo(() => {
    const result = new Map<string, string>();
    const stories = (data?.stories ?? []) as unknown as ISbStoryData[];
    stories.forEach((s) => {
      if (s.uuid && s.full_slug) {
        result.set(s.uuid, s.full_slug);
      }
    });
    return result;
  }, [data]);

  return { map, isLoading, isError };
};
